import styled from '@xstyled/styled-components'

export const CommonGridContainer = styled.div`
  flex: 1;
  overflow: auto;
  max-width: 100vw;
  width: 100%;
  padding: 0 8px;

  @media (min-width: 1024px) {
    padding: 0;
  }
`
